import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Input, Button, Tag, Table } from 'antd';

import requestAPI from 'helpers/requestAPI';
import MainMenu from 'components/mainMenu';
import { toastError, toastSuccess } from 'utils/toastr';
import NSModal from './nsModal';
import RegistrModal from './registrModal';

import './index.scss';

const AutoPurchase = () => {
	const [ query, setQuery ] = useState('');
	const [ registOptions, setRegistrOptions ] = useState([]);
	const [ nsOptions, setNsOptions ] = useState([]);
	const [ ns, setNs ] = useState('');
	const [ regist, setRegist ] = useState(null);
	const [ dataTable, setDataTable ] = useState([]);
	const [ loadingTable, setLoadingTable ] = useState(false);
	const [ visibleModal, setVisibleModal ] = useState(false);
	const [ visibleModalRegistrator, setVisibleModalRegistrator ] = useState(false);
	const [ editMode, setEditMode ] = useState({
		registrar: false,
		ns: false
	});


	const fetchNs = () => {
		const params2 = {
			routeParams: {
				route: 'name_servers_template'
			}
		};

		requestAPI(params2)
			.then((resp) => {
				const nameServers = [];
				resp.data.data.forEach((element) => {
					if (!nameServers.includes(element.host_url)) {
						nameServers.push(element.host_url);
					}
				});

				if (nameServers.length) setNs(nameServers[0]);
				setNsOptions(nameServers);
			})
			.catch((error) => {
				toastError('Something went wrong');
			});
	};

	const fetchRegistr = () => {
		const params = {
			routeParams: {
				route: 'domain_register'
			}
		};

		requestAPI(params)
			.then((resp) => {
				const registers = resp.data.data.map((item) => {
					return {
						id: item.id,
						name: item.name
					};
				});

				if (registers.length) setRegist(registers[0].id);
				setRegistrOptions(registers);
			})
			.catch((error) => {
				toastError(error);
			});
	};

	useEffect(() => {
		fetchRegistr();
		fetchNs();
	}, []);

	const { Option } = Select;
	const { TextArea } = Input;

	const handleDeleteNs = async () => {
		const params = {
			routeParams: {
				route: 'name_servers_template'
			}
		};

		const nsList = await requestAPI(params).then((resp) => {
			return resp.data.data
				.filter((elem) => {
					return elem.host_url === ns;
				})
				.map((elem) => {
					return elem.id;
				});
		});

		nsList.forEach((elem, i) => {
			const deleteParams = {
				routeParams: {
					route: 'name_servers_template',
					id: elem
				},
				method: 'DELETE'
			};

			requestAPI(deleteParams)
				.then(() => {
					if (i === nsList.length - 1) {
						fetchNs();
						toastSuccess('Deleted');
					}
				})
				.catch((err) => toastError(err));
		});
	};

	const handleDeleteRegistrator = () => {
		const params = {
			routeParams: {
				route: 'domain_register',
				id: regist
			},
			method: 'DELETE'
		};

		requestAPI(params)
			.then(() => {
				fetchRegistr();
				toastSuccess('Deleted!');
			})
			.catch((err) => toastError(err));
	};

	const handleClickStart = async () => {
		if (!query) {
			toastError('Enter query');
			return;
		}

		setLoadingTable(true);

		const params = {
			routeParams: {
				route: 'name_servers_template'
			}
		};

		const nsList = await requestAPI(params)
			.then((resp) => {
				return resp.data.data
					.filter((elem) => {
						return elem.host_url === ns;
					})
					.map((elem) => {
						return elem.ns;
					});
			})
			.catch((err) => toastError(err));

		const params2 = {
			routeParams: {
				route: 'domain_register',
				id: regist
			},
			method: 'POST',
			data: {
				domain_list: query.split('\n'),
				ns_list: nsList
			}
		};

		requestAPI(params2)
			.then((resp) => {
				const data = [];
				for (let key in resp.data.data) {
					data.push({ key, name: key, status: resp.data.data[key] });
				}

				setDataTable(data);
				setLoadingTable(false);
			})
			.catch((err) => toastError(err));
	};

	const handleEditRegistrator = () => {
		setEditMode({ ...editMode, registrar: true });
		setVisibleModalRegistrator(true);
	};
	const handleEditNs = () => {
		setEditMode({ ...editMode, ns: true });
		setVisibleModal(true);
	};

	const handleAddRegistrator = () => {
		setEditMode({ ...editMode, registrar: false });
		setVisibleModalRegistrator(true);
	}

	const handleAddNs = () => {
		setEditMode({ ...editMode, ns: false });
		setVisibleModal(true);
	}

	const handleChangeTextArea = (e) => {
		setQuery(e.target.value);
	}

	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			width: '60%'
		},
		{
			title: 'Status',
			dataIndex: 'status',
			key: 'status',
			width: '40%',
			render: (value) => {
				return value === true ? <Tag color="green">{`${value}`}</Tag> : <p style={{color: '#FF4D4F'}}>{`${value}`}</p>;
			}
		}
	];

	const changeVisibleNsModal = () => {
		setVisibleModal(false);
		setEditMode({ ...editMode, ns: false });
	}

	const changeVisibleRegistrarModal = () => {
		setVisibleModalRegistrator(false);
		setEditMode({ ...editMode, registrar: false });
	}

	return (
		<div className="auto-purchase">
			<MainMenu />
			<p className = 'auto-purchase__titile__description'>Тут можно массово поменять NS на регистраторах</p>
			<Row className="auto-purchase__wrapper">
				<Col span={10}>
					<Row gutter={[ 0, 20 ]} type="flex" align="middle">
						<Col span={8}>Select registrator:</Col>
						<Col span={12}>
							<Row className="auto-purchase__ns-row">
								<Select value={regist} onSelect={value => setRegist(value)} className="auto-purchase__ns-row__select">
									{registOptions &&
										registOptions.map((elem, i) => {
											return (
												<Option key={i} value={elem.id}>
													{elem.name}
												</Option>
											);
										})}
								</Select>
								<Button
									className="auto-purchase__ns-row__button"
									onClick={handleAddRegistrator}
									type="primary"
								>
									Add
								</Button>
								<Button onClick={handleEditRegistrator} className="auto-purchase__ns-row__button" type="primary" ghost>
									Edit
								</Button>
								<Button className="auto-purchase__ns-row__button" onClick={handleDeleteRegistrator} type="danger">
									Delete
								</Button>
							</Row>
						</Col>
					</Row>
					<Row gutter={[ 0, 20 ]} type="flex" align="middle">
						<Col span={8}>Select NameServer:</Col>
						<Col span={12}>
							<Row className="auto-purchase__ns-row">
								<Select
									className="auto-purchase__ns-row__select"
									value={ns}
									onSelect={ns => setNs(ns)}
								>
									{nsOptions &&
										nsOptions.map((item, i) => {
											return (
												<Option value={item} key={i}>
													{item}
												</Option>
											);
										})}
								</Select>
								<Button
									className="auto-purchase__ns-row__button"
									onClick={handleAddNs}
									type="primary"
								>
									Add
								</Button>
								<Button onClick={handleEditNs} className="auto-purchase__ns-row__button" type="primary" ghost>
									Edit
								</Button>
								<Button onClick={handleDeleteNs} type="danger">
									Delete
								</Button>
							</Row>
						</Col>
					</Row>
					<Row gutter={[ 0, 20 ]}>
						<Col span={20}>
							<TextArea
								value={query}
								autoSize={{ minRows: 5 }}
								onChange={handleChangeTextArea}
							/>
						</Col>
					</Row>
					<Row>
						<Col span={20} className="auto-purchase__button-column">
							<Button
								disabled={loadingTable}
								onClick={handleClickStart}
								type="primary"
								size="large"
								className="auto-purchase__start-button"
							>
								Start
							</Button>
						</Col>
					</Row>
				</Col>
				<Col span={10}>
					<Col span={20}>
						<Row>Script execution logs:</Row>
						<Table
							columns={columns}
							dataSource={dataTable}
							pagination={true}
							size={'small'}
							loading={loadingTable}
							// scroll={{ y: '100%' }}
						/>
					</Col>
				</Col>
			</Row>
			<NSModal
				hostName={ns}
				editMode={editMode.ns}
				visible={visibleModal}
				updateNS={fetchNs}
				changeVisible={changeVisibleNsModal}
			/>
			<RegistrModal
				registrId={regist}
				editMode={editMode.registrar}
				visible={visibleModalRegistrator}
				updateRegistr={fetchRegistr}
				changeVisible={changeVisibleRegistrarModal}
			/>
		</div>
	);
};

export default AutoPurchase;
